import React, { createContext, useContext, useState } from 'react'

const LocaleContext = createContext({ locale: 'fr', t: (k) => k, setLocale: () => {} })

const translations = {
  fr: {
    dashboard: 'Tableau de bord',
    promos: 'Promos',
    planner: 'Planning repas',
    stock: 'Stock',
    shopping: 'Courses',
    recipes: 'Recettes',
    history: 'Historique',
    today: "Aujourd'hui",
    breakfast: 'Petit-déjeuner',
    lunch: 'Déjeuner',
    dinner: 'Dîner',
    snack: 'Collation',
    prepared: 'Préparé',
    planned: 'Planifié',
    skipped: 'Passé',
    fridge: 'Frigo',
    freezer: 'Congélateur',
    cupboard: 'Placard',
    analyze: 'Analyser',
    scan: 'Scanner',
    add: 'Ajouter',
    save: 'Enregistrer',
    cancel: 'Annuler',
    delete: 'Supprimer',
    loading: 'Chargement…',
    suggestions: 'Suggestions',
    week: 'Semaine',
    expires_soon: 'Expire bientôt',
    expired: 'Expiré',
    'lactose-free': 'Sans lactose',
    shopping_list: 'Liste de courses',
    generate_list: 'Générer la liste',
    scan_receipt: 'Scanner un reçu',
    scan_fridge: 'Scanner le frigo',
    ai_suggest: 'Suggestions IA',
    household: 'Foyer',
    members: 'Membres',
    add_member: 'Ajouter un membre',
    member_name: 'Prénom',
    member_age: 'Âge',
    member_allergies: 'Allergies',
    member_preferences: 'Préférences',
    no_members: 'Aucun membre — ajoutez le premier !',
  },
  en: {
    dashboard: 'Dashboard',
    promos: 'Promos',
    planner: 'Meal Planner',
    stock: 'Stock',
    shopping: 'Shopping',
    recipes: 'Recipes',
    history: 'History',
    today: 'Today',
    breakfast: 'Breakfast',
    lunch: 'Lunch',
    dinner: 'Dinner',
    snack: 'Snack',
    prepared: 'Prepared',
    planned: 'Planned',
    skipped: 'Skipped',
    fridge: 'Fridge',
    freezer: 'Freezer',
    cupboard: 'Cupboard',
    analyze: 'Analyze',
    scan: 'Scan',
    add: 'Add',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    loading: 'Loading…',
    suggestions: 'Suggestions',
    week: 'Week',
    expires_soon: 'Expires soon',
    expired: 'Expired',
    'lactose-free': 'Lactose-free',
    shopping_list: 'Shopping list',
    generate_list: 'Generate list',
    scan_receipt: 'Scan receipt',
    scan_fridge: 'Scan fridge',
    ai_suggest: 'AI Suggestions',
    household: 'Household',
    members: 'Members',
    add_member: 'Add member',
    member_name: 'Name',
    member_age: 'Age',
    member_allergies: 'Allergies',
    member_preferences: 'Preferences',
    no_members: 'No members yet — add the first!',
  },
}

export function LocaleProvider({ children, defaultLocale = 'fr' }) {
  const [locale, setLocale] = useState(defaultLocale)
  const t = (key) => translations[locale]?.[key] ?? translations.fr[key] ?? key
  return React.createElement(LocaleContext.Provider, { value: { locale, t, setLocale } }, children)
}

export function useLocale() {
  return useContext(LocaleContext)
}
